import React from 'react';
import { LogOut, BarChart3, KeyRound, GraduationCap, Building2, Shield, Mail, Inbox, EyeOff, MessageSquareHeart } from 'lucide-react';
import HSTLogo from '../../HSTLogo';

const TABS = [
  { id: 'dashboard', label: 'Tableau de bord', icon: BarChart3, testid: 'tab-dashboard' },
  { id: 'licenses', label: 'Licences', icon: KeyRound, testid: 'tab-licenses' },
  { id: 'cohorts', label: 'Cohortes', icon: GraduationCap, testid: 'tab-cohorts' },
  { id: 'establishments', label: 'Établissements', icon: Building2, testid: 'tab-establishments' },
  { id: 'leads', label: 'Leads', icon: Inbox, testid: 'tab-leads' },
  { id: 'rex', label: 'REX', icon: MessageSquareHeart, testid: 'tab-rex' },
  { id: 'supervision', label: 'Super Vue', icon: Shield, testid: 'tab-supervision' },
  { id: 'notifications', label: 'Notifications', icon: Mail, testid: 'tab-notifications' },
];

/**
 * Admin — Top header (logo, tabs nav, admin email + logout).
 * Extracted from AdminPanel.jsx on 29/05/2026 (code review refactor).
 * 03/06/2026 — Promoted the "Hide TEST_*" toggle from LicensesTab to the
 * global header so it now affects ALL admin tabs.
 */
export default function AdminHeader({ adminEmail, tab, setTab, onLogout, hideTest, setHideTest, testCount }) {
  return (
    <div className="bg-accent text-white px-6 py-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <HSTLogo size={32} withGlow={false} />
        <h1 className="font-bold text-lg">HST — Admin Panel</h1>
      </div>
      <div className="flex items-center gap-4">
        <div className="flex gap-1 bg-ink-800/10 rounded-lg p-1">
          {TABS.map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
                tab === t.id ? 'bg-ink-800 text-foreground' : 'text-foreground/70 hover:text-foreground'
              }`}
              data-testid={t.testid}
            >
              <t.icon className="w-3.5 h-3.5 inline mr-1" /> {t.label}
            </button>
          ))}
        </div>
        {typeof setHideTest === 'function' && (
          <label
            className="flex items-center gap-1.5 text-xs cursor-pointer select-none px-2 py-1 rounded bg-ink-800/10 hover:bg-ink-800/20 transition-colors"
            data-testid="admin-hide-test-toggle"
            title={`Masquer les licences TEST_* (${testCount || 0} actuellement détectées)`}
          >
            <input
              type="checkbox"
              checked={!!hideTest}
              onChange={(e) => setHideTest(e.target.checked)}
              className="accent-white"
              data-testid="admin-hide-test-checkbox"
            />
            <EyeOff className="w-3 h-3" />
            <span>Cacher TEST</span>
            {!!testCount && (
              <span className="text-[10px] bg-ink-800/30 rounded px-1 py-0.5 font-mono">{testCount}</span>
            )}
          </label>
        )}
        <span className="text-sm text-slate-400">{adminEmail}</span>
        <button onClick={onLogout} className="p-2 hover:bg-ink-800/10 rounded-lg" data-testid="admin-logout">
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

